export default __webpack_public_path__ + "static/media/accuracy-icon.be2a4cd5.png";